import { useCallback, useEffect, useState } from "react";
import FormModalSecteur from "../FormModalSecteur";
import FormModalMetier from "../FormModalMetier"; // 👉 un nouveau modal pour gérer les métiers
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import './styles.css';
import { useSelector } from "react-redux";
import CertifModalForm from "../CertifModalForm";

export default function GestionSecteur() {
    const [secteurs, setSecteurs] = useState([]);
    const [secteurToUpdate, setSecteurToUpdate] = useState(null);
    const [metierToUpdate, setMetierToUpdate] = useState(null);
    const [secteurForNewMetier, setSecteurForNewMetier] = useState(null);
    const [showFormSecteur, setShowFormSecteur] = useState(false);
    const [showFormMetier, setShowFormMetier] = useState(false);
    const [showFormCertif, setShowFormCertif] = useState(false);
    const [secteurForNewCertif, setSecteurForNewCertif] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [openSecteur, setOpenSecteur] = useState(null);
    const [openMetiers, setOpenMetiers] = useState(null);
    const [openCertifs, setOpenCertifs] = useState(null);
    const [openNafsSecteur, setOpenNafsSecteur] = useState(null);
    const [prefixNaf, setPrefixNaf] = useState("");
    const apiUrl = process.env.REACT_APP_API_URL;

    const refreshSecteurs = useCallback(() => {
        const url = `${apiUrl}/api/secteurs`;
        setLoading(true);

        return fetch(url, { method: "GET" })
            .then((res) => res.json())
            .then((data) => setSecteurs(data))
            .catch((err) => console.error("Erreur chargement secteurs :", err))
            .finally(() => setLoading(false));
    }, [apiUrl]);

    useEffect(() => {
        refreshSecteurs();
    }, [refreshSecteurs]);

    const { token } = useSelector((state) => state.auth); // récupère le token

    const handleDeleteSecteur = (id) => {
        if (!window.confirm("Supprimer ce secteur ?")) return;

        fetch(`${apiUrl}/api/secteurs/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                if (!res.ok) throw new Error("Erreur suppression secteur");
                return res.json();
            })
            .then(() => refreshSecteurs())
            .catch((err) => console.error(err));
    };

    const handleDeleteMetier = (idMetier, idSecteur) => {
        if (!window.confirm("Supprimer ce métier de ce secteur d'activité ?")) return;

        fetch(`${apiUrl}/api/metiers/${idMetier}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ idSecteur }),

        })
            .then((res) => {
                if (!res.ok) throw new Error("Erreur suppression métier");
                return res.json();
            })
            .then(() => refreshSecteurs())
            .catch((err) => console.error(err));
    };

    const handleAddPrefixNaf = async () => {
        if (!openNafsSecteur) return;

        const cleanPrefix = prefixNaf.trim();

        if (!/^\d{2}$/.test(cleanPrefix)) {
            setError("Le préfixe NAF doit contenir 2 chiffres (ex: 62)");
            return;
        }

        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("prefixNaf", cleanPrefix);
        formData.append("idSecteur", openNafsSecteur);

        try {
            const response = await fetch(`${apiUrl}/api/nafSecteur`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de l’enregistrement du préfixe NAF.");
            }

            setPrefixNaf(""); // reset champ
            refreshSecteurs();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <section className="secteur-section">
            <h2>Gestion des secteurs d'activités et des métiers</h2>
            <button
                className="btn-add-secteur"
                onClick={() => { setSecteurToUpdate(null); setShowFormSecteur(true) }}
            >
                <FontAwesomeIcon icon={faPlus} /> AJOUTER UN SECTEUR D'ACTIVITES
            </button>
            {loading ? (
                <div className="loader">
                    <div className="spinner"></div>
                    Chargement des secteurs...
                </div>
            ) : (
                <div className="secteur-accordion">
                    {secteurs.length > 0 && secteurs.map((secteur) => {
                        // Si un secteur est ouvert, on n’affiche que celui-là
                        if (openSecteur && openSecteur !== secteur.idSecteur) return null;
                        return (
                            <div key={secteur.idSecteur} className="secteur-item">
                                <div
                                    className="secteur-header"
                                    onClick={() => setOpenSecteur(openSecteur === secteur.idSecteur ? null : secteur.idSecteur)}
                                >
                                    <div className="secteur-info">
                                        <img
                                            src={`${apiUrl}/api/files/?categorie=secteurs&file=${secteur.iconSecteur}`}
                                            alt="icone secteur"
                                            className="secteur-icon"
                                        />
                                        <span>{secteur.labelSecteur}</span>
                                    </div>
                                    <div className="secteur-actions">
                                        <button
                                            className="btn-icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSecteurToUpdate(secteur);
                                                setShowFormSecteur(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        <button
                                            className="btn-icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteSecteur(secteur.idSecteur);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                        <FontAwesomeIcon
                                            icon={openSecteur === secteur.idSecteur ? faChevronUp : faChevronDown}
                                            className="chevron"
                                        />
                                    </div>
                                </div>

                                <div className={`secteur-body ${openSecteur === secteur.idSecteur ? "open" : ""}`}>

                                    {/* === ACCORDÉON MÉTIERS === */}
                                    <div className="sub-accordion">
                                        <div
                                            className="sub-accordion-header"
                                            onClick={() =>
                                                setOpenMetiers(openMetiers === secteur.idSecteur ? null : secteur.idSecteur)
                                            }
                                        >
                                            <h4>Métiers et services</h4>
                                            <FontAwesomeIcon
                                                icon={openMetiers === secteur.idSecteur ? faChevronUp : faChevronDown}
                                            />
                                        </div>

                                        {openMetiers === secteur.idSecteur && (
                                            <div className="sub-accordion-body">
                                                <div className="metiers-list">
                                                    {secteur.metiers && secteur.metiers.length > 0 ? (
                                                        secteur.metiers.map((metier) => (
                                                            <div key={metier.idMetier} className="metier-item">
                                                                <div className="metier-info">
                                                                    {metier.iconMetier && (
                                                                        <img
                                                                            src={`${apiUrl}/api/files/?categorie=metiers&file=${metier.iconMetier}`}
                                                                            alt="icone metier"
                                                                            className="metier-icon"
                                                                        />
                                                                    )}
                                                                    <span>{metier.labelMetier}</span>
                                                                </div>
                                                                <div className="metier-actions">
                                                                    <button
                                                                        className="btn-icon"
                                                                        onClick={() => {
                                                                            setMetierToUpdate(metier);
                                                                            setShowFormMetier(true);
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faPen} />
                                                                    </button>
                                                                    <button
                                                                        className="btn-icon"
                                                                        onClick={() =>
                                                                            handleDeleteMetier(metier.idMetier, secteur.idSecteur)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="metiers-placeholder">
                                                            <em>Aucun métier ou service pour ce secteur</em>
                                                        </div>
                                                    )}
                                                </div>

                                                <button
                                                    className="btn-add-metier"
                                                    onClick={() => {
                                                        setSecteurForNewMetier(secteur);
                                                        setMetierToUpdate(null);
                                                        setShowFormMetier(true);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faPlus} /> Ajouter un métier ou un service
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <div className="sub-accordion">
                                        <div
                                            className="sub-accordion-header"
                                            onClick={() =>
                                                setOpenNafsSecteur(openNafsSecteur === secteur.idSecteur ? null : secteur.idSecteur)
                                            }>
                                            <h4>CODES NAF CORRESPONDANTS</h4>
                                            <FontAwesomeIcon
                                                icon={openNafsSecteur === secteur.idSecteur ? faChevronUp : faChevronDown}
                                            />
                                        </div>
                                        {
                                            openNafsSecteur === secteur.idSecteur && (
                                                <div className="sub-accordion-body">
                                                    <input type="text" name="prefixNaf" value={prefixNaf} onChange={(e) => setPrefixNaf(e.target.value)} />
                                                    <button
                                                        className="btn-add-certif"
                                                        onClick={handleAddPrefixNaf}
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} /> Ajouter
                                                    </button>
                                                    <div className="certifs-list">
                                                        {secteur.nafs && secteur.nafs.length > 0 ? (
                                                            secteur.nafs.map((naf) => (
                                                                <div key={naf.idNafSecteur} className="certif-item">
                                                                    <div className="certif-info">

                                                                        <span>{naf.nafPrefix}</span>
                                                                    </div>
                                                                    <div className="certif-actions">
                                                                        <button
                                                                            className="btn-icon"
                                                                            onClick={() => {
                                                                                if (!window.confirm("Supprimer ce préfixe naf ?")) return;
                                                                                fetch(
                                                                                    `${apiUrl}/api/nafSecteur?idNafSecteur=${naf.idNafSecteur}`,
                                                                                    {
                                                                                        method: "DELETE",
                                                                                        headers: { Authorization: `Bearer ${token}` },
                                                                                    }
                                                                                )
                                                                                    .then((res) => res.json())
                                                                                    .then(() => refreshSecteurs())
                                                                                    .catch((err) => console.error(err));
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="certifs-placeholder">
                                                                <em>Aucun préfixe naf pour ce secteur</em>
                                                            </div>
                                                        )}
                                                    </div>


                                                </div>
                                            )
                                        }
                                    </div>

                                    {/* === ACCORDÉON CERTIFICATIONS === */}
                                    <div className="sub-accordion">
                                        <div
                                            className="sub-accordion-header"
                                            onClick={() =>
                                                setOpenCertifs(openCertifs === secteur.idSecteur ? null : secteur.idSecteur)
                                            }
                                        >
                                            <h4>Certifications</h4>
                                            <FontAwesomeIcon
                                                icon={openCertifs === secteur.idSecteur ? faChevronUp : faChevronDown}
                                            />
                                        </div>

                                        {openCertifs === secteur.idSecteur && (
                                            <div className="sub-accordion-body">
                                                <div className="certifs-list">
                                                    {secteur.certifs && secteur.certifs.length > 0 ? (
                                                        secteur.certifs.map((certif) => (
                                                            <div key={certif.idCertif} className="certif-item">
                                                                <div className="certif-info">
                                                                    {certif.logo && (
                                                                        <img
                                                                            src={`${apiUrl}/api/files/?categorie=certifications&file=${certif.logo}`}
                                                                            alt={certif.nomCertif}
                                                                            className="certif-logo"
                                                                        />
                                                                    )}
                                                                    <span>{certif.nomCertif}</span>
                                                                </div>
                                                                <div className="certif-actions">
                                                                    <button
                                                                        className="btn-icon"
                                                                        onClick={() => {
                                                                            if (!window.confirm("Supprimer cette certification ?")) return;
                                                                            fetch(
                                                                                `${apiUrl}/api/certifs/${certif.idCertif}`,
                                                                                {
                                                                                    method: "DELETE",
                                                                                    headers: { Authorization: `Bearer ${token}` },
                                                                                    body: JSON.stringify({ idSecteur: secteur.idSecteur }),
                                                                                }
                                                                            )
                                                                                .then((res) => res.json())
                                                                                .then(() => refreshSecteurs())
                                                                                .catch((err) => console.error(err));
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="certifs-placeholder">
                                                            <em>Aucune certification pour ce secteur</em>
                                                        </div>
                                                    )}
                                                </div>

                                                <button
                                                    className="btn-add-certif"
                                                    onClick={() => {
                                                        setSecteurForNewCertif(secteur);
                                                        setShowFormCertif(true);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faPlus} /> Ajouter une certification
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        );
                    })}
                    {secteurs.length === 0 && <>Aucun secteur trouvé</>}
                </div>

            )}

            {showFormSecteur && (
                <FormModalSecteur
                    onClose={() => setShowFormSecteur(false)}
                    refresh={refreshSecteurs}
                    secteurToUpdate={secteurToUpdate}
                />
            )}
            {showFormMetier && (
                <FormModalMetier
                    onClose={() => setShowFormMetier(false)}
                    refresh={refreshSecteurs}
                    metierToUpdate={metierToUpdate}
                    secteur={secteurForNewMetier}
                />
            )}
            {showFormCertif && (
                <CertifModalForm
                    onClose={() => setShowFormCertif(false)}
                    secteur={secteurForNewCertif}
                    refresh={refreshSecteurs}
                />
            )}

        </section>
    );
}
